import { AnalyticsEventProperties } from 'core/analytics/entities';
import { FunnelImage, ScreenBackground, WhyModal } from '../Content';
import { BaseScreenAttributes } from './BaseScreenAttributes';
import { ScreenType } from './ScreenType';

export enum Calculation {
  NONE = 'none',
  NATAL_CHART = 'natal-chart',
}

export interface PlaceScreenAttributes extends BaseScreenAttributes {
  dataKey: string;
  locationDataKey: string;
  calculation?: Calculation;
  content: {
    title: string;
    text: string;
    button?: {
      icon?: FunnelImage;
      text: string;
    };
    modal?: WhyModal;
    placeholder: string;
    image?: FunnelImage;
    cancel?: string;
    next?: string;
    backgroundImage: ScreenBackground;
  };
  skipData?: {
    text: string;
    defaultPlace: string;
    defaultCoordinates: Array<number>;
  };
  screenType: ScreenType.PLACE;
}

export type PlaceScreenProps = {
  onBack: () => void;
  onSubmit: (coordinates: number[], location: string) => void;
  onTrackClickEvent: (properties?: AnalyticsEventProperties) => void;
  initialLocation: string;
  initialCoordinates: number[];
  step: number;
  isSubmitting: boolean;
} & PlaceScreenAttributes;
